<template>
    <CmsPage>
      <template #after-content>
        <a id="setCookie" class="sf-button color-secondary" href="javascript:openAxeptioCookies()">Je modifie mes choix en matière de cookies
        </a>
      </template>
    </CmsPage>
</template>

<script>
import CmsPage from "@/pages/CMS/CmsPage.vue";

export default {
    name: "Cookies",
    components: {
        CmsPage
    }
}
</script>

<style lang="scss" scoped>
#setCookie {
  text-align: center;
  display: inline-block;
  margin: var(--spacer-base) auto var(--spacer-xl);
}
</style>